import * as React from "react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { basePathSelector, roomSelector } from "../selectors";
import { AppState, RoomCreateUpdateModel } from "../model";
import { saveRoom } from "../actions";
import { SAVE_ROOM } from "../actiontypes";

import { CreateEditModal } from "./CreateEditModal";

import { push } from "redux-little-router";

export const Edit: React.FC = () => {
    const dispatch = useDispatch();
    const basePath = useSelector(basePathSelector);
    const defaultValues = useSelector((state: AppState) => (roomSelector(state) ?? {}) as RoomCreateUpdateModel);
    const id = useSelector((state: AppState) => state.router.params!.roomId);

    const save = React.useCallback((room: RoomCreateUpdateModel) => dispatch(saveRoom(id, room, basePath)), [basePath, dispatch, id]);

    const open = useSelector((state: AppState) => state.router.pathname?.endsWith("/edit") ?? false);
    const close = React.useCallback(() => dispatch(push(`${basePath}/${id}`, {})), [basePath, dispatch, id]);

    return (
        <CreateEditModal open={open} save={save} close={close} defaultValues={defaultValues} isSavingRequestName={SAVE_ROOM} modalTitle="Edit Room" />
    );
};
